// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ElbridgeHookVO')
export class ElbridgeHookVO {
  @JsonProperty('hookUrl', 'String')
  public hookUrl: string = undefined;

  @JsonProperty('version', 'String')
  public version: string = undefined;
}
